import { styled } from '@mui/material/styles';
import { themeOptions } from 'assets/styles/theme';

export const SubTitle = styled('div')`
  color: ${themeOptions.palette?.text?.primary};
  font-size: 14px;
  font-weight: ${themeOptions.typography.fontWeightRegular};
  margin-top: 4px;
  margin-bottom: 16px;
`;
